import { FormControl, FormLabel, Switch } from '@chakra-ui/react'
import { RecordLabel } from './types'
import { getPluralLabel } from './utils'

interface Props {
  recordLabel: RecordLabel
  showCompleted: boolean
  onChange: (checked: boolean) => void
}

/**
 * Toggle switch for showing/hiding completed regimen items
 * 
 * Displays contextual label based on regimen type:
 * - "Show completed supplements"
 * - "Show completed medications"
 * - etc.
 */
export default function ShowCompletedSwitch({
  recordLabel,
  showCompleted,
  onChange,
}: Props) {
  const pluralLabel = getPluralLabel(recordLabel)

  return (
    <FormControl display='flex' alignItems='center'>
      <FormLabel htmlFor='show-completed' mb='0'>
        Show completed {pluralLabel}
      </FormLabel>
      <Switch
        id='show-completed'
        size='md'
        isChecked={showCompleted}
        onChange={(e) => onChange(e.target.checked)}
      />
    </FormControl>
  )
}
